<style lang="stylus">
    .image-pulse {
        position absolute
        cursor pointer
        z-index 2
        width 40px
        height 40px
        &.is-sdk {
            box-shadow: $box-shadow;
            border-radius 8px;
            .ai-entry-icon {
                box-shadow: none;
                width 40px;
                height 40px;
                background-image: url(../assets/img/ai4/ai-bot-entry.svg);
                display flex
                align-items center;
                justify-content center
                .edrawai-img-wrapper {

                }

                .edrawai-img {
                    position: relative;
                    width: 28px;
                    height: 28px;
                    // margin-bottom: 16px;
                    overflow: hidden;
                    background-image: url(../assets/img/ai4/canvas-loading.png);
                    background-repeat: no-repeat;
                    background-position: 0 0;
                    background-size: auto 28px;
                    animation: edrawai 1.5s steps(31) infinite;
                }
            }
        }
        .ai-entry-icon {
            width 100%
            height 100%
            box-shadow: 0px 2px 6px 0px rgba(0, 23, 142, 0.1), 0px 0px 16px 0px rgba(0, 23, 142, 0.15);
            border-radius 8px;
            position relative;
            img {
                height 40px;
                width 40px;
            }
        }
        .rightmenu {

            position absolute
            left 0
            top 0
            height 30px
            background #fff
            border-radius 6px
            z-index 10
        }
    }
    @keyframes edrawai {
        0% {
            background-position: 0 0;
        }

        100% {
            background-position: -868px, 0;
        }
    }
    html.light {
        .image-pulse.is-sdk  {
            .ai-entry-icon {
                background-image: url(../assets/img/ai4/ai-bot-entry-light.svg);
            }
        }
    }
</style>

<template>
    <div
        v-show="userShowAIBotEntry"
        ref="dragItem"
        :style="iconPositon"
        class="image-pulse"
        :class="{ 'is-sdk': EDCONFIG.IS_SDK }"
        @contextmenu="showAIRightMenu"
    >
        <div class="ai-entry-icon" ref="dragbox" @click.stop="toggleShow">
            <img :src="require('@/app/assets/img/ai4/ai4-bot-entry.gif')" draggable="false" v-if="!EDCONFIG.IS_SDK" />
            <div v-else class="edrawai-img-wrapper">
                <div class="edrawai-img"></div>
            </div>
        </div>
        <div v-if="showRightMenu" class="rightmenu" :style="{ left: `${rightMenuL}px`, top: `${rightMenuT}px` }">
            <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)"></MenuList>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    import dragTool from "@/app/components/FloatTool/dragTool";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: { MenuList },
    })
    export default class AIBotEntry extends Mixins(dragTool) {
        @Prop() customOffset;
        @Prop() screenData;

        dragActive = true;
        position = {
            right: 16,
            top: 16,
        };

        get iconPositon() {
            if (this.customOffset) {
                return `right: ${this.customOffset.right}px; top: ${this.customOffset.top}px`;
            } else {
                return `right: ${parseFloat(this.screenData.right) + this.position.right}px; top: ${
                    parseFloat(this.screenData.top) + this.position.top
                }px`;
            }
        }
        get showAIBotDialog() {
            return this.$store.state.ui.showAIBotDialog;
        }
        set showAIBotDialog(v) {
            this.$store.commit("setStatus", {
                type: "showAIBotDialog",
                data: v,
            });
        }
        get userShowAIBotEntry() {
            return this.$store.state.ui.userShowAIBotEntry;
        }
        set userShowAIBotEntry(v) {
            this.$store.commit("setStatus", {
                type: "userShowAIBotEntry",
                data: v,
            });
        }

        get showAIBotEntry() {
            return this.$store.state.ui.showAIBotEntry;
        }
        set showAIBotEntry(v) {
            this.$store.commit("setStatus", {
                type: "showAIBotEntry",
                data: v,
            });
        }

        showRightMenu = false;
        get menuList() {
            const resultList = [{ key: "talk", label: this.$t("hidden") }];
            return { container: "AI-entry", list: resultList };
        }
        rightMenuL = 0;
        rightMenuT = 0;
        showAIRightMenu(e) {
            this.rightMenuL = e.offsetX;
            this.rightMenuT = e.offsetY;
            this.showRightMenu = true;
            const close = () => {
                this.showRightMenu = false;
                document.removeEventListener("click", close);
            };
            document.addEventListener("click", close);
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            event.stopPropagation();
            this.userShowAIBotEntry = false;
            this.showRightMenu = false;
        }

        toggleShow() {
            if (this.isMoving) return;
            // this.showAIBotDialog = !this.showAIBotDialog;
            // if (this.showAIBotDialog) {
            //     this.sensors.track("openAISmartAssistant", {
            //         Catalogues: "AI",
            //         open_way: "from_button",
            //     });
            // }
            this.$bus.$emit("showAIPanel", true);
            this.showAIBotEntry = false;
            this.sensors.track("openAI", {
                Catalogues: "AI",
                open_way: "from_button",
            });
        }
        handleClickEmpty() {}

        dragElement = null;
        moveElement = null;
        mounted() {
            this.dragElement = this.$refs.dragbox as HTMLElement;
            this.moveElement = this.$refs.dragItem as HTMLElement;

            const safeAreaDom = document.getElementById("scene");
            if (safeAreaDom) {
                new (window as any).ResizeObserver((entries) => {
                    const cr = entries[0].contentRect;
                    const { sceneLeft, sceneTop } = this.$store.state.ui;
                    this.setSafeArea({
                        minX: sceneLeft,
                        minY: sceneTop,
                        maxX: cr.width + sceneLeft,
                        maxY: cr.height + sceneTop,
                    });
                }).observe(safeAreaDom);
            }
            this.drag(this.dragElement, this.moveElement);
        }
    }
</script>
<i18n>
{
    "zh": {
        "hidden": "关闭"
    },
    "en": {
        "hidden": "close"
    },
    "fr": {
        "hidden": "Fermer"
    },
    "de": {
        "hidden": "Schließen"
    },
    "jp": {
        "hidden": "閉じる"
    },
    "es": {
        "hidden": "Cerrar"
    },
    "pt": {
        "hidden": "Fechar"
    },
    "it": {
        "hidden": "Chiudi"
    },
    "tw": {
        "hidden": "關閉"
    }
}
</i18n>
